module.exports = __webpack_public_path__ + "media/images/icons/search-9a94fdc62b3b9f6b01b97cd060672eb4.svg";